import { Entity } from "@common/entities/entity.model";
import { DataTable } from "components/elements/Datatable/data-table";
import { EntitiesTable } from "./components/entities-table";
import { EntityForm } from "./components/entity-form";
import WidgetBox from "components/elements/WidgetBox/widget-box";

type EntitiesProps = {
  companyId: string;
};

export function Entities({ companyId }: EntitiesProps) {
  return (
    <WidgetBox>
      <DataTable<Entity>
        resource={{
          path: "entities",
          name: "Entity",
          title: "Entities",
        }}
        table={<EntitiesTable />}
        form={<EntityForm />}
        params={{
          company: companyId,
        }}
      />
    </WidgetBox>
  );
}
